import React, { useState } from "react";
import Scrollbar from "../../../scrollbar";
import { MdSort } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../utils/redux/hooks";
import { RootState } from "../../../../utils/redux/store";
import { addviewOrder } from "../../../../utils/redux/mainSlice";

const Pending = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const customerOrders = useAppSelector(
    (store: RootState) => store.user.customerOrders
  );
  const pending = customerOrders?.filter((item) => item?.status === "PENDING");

  const [data, setdata] = useState(pending || []);

  const itemsPerPage = 15;
  const totalItems = data?.length;

  const allItems = Array.from({ length: itemsPerPage }, (_, index) => ({
    id: index + 1,
    date: `16 Sep 2023 13:56`,
    amount: `₦  10,000`,
    orderId: `201456`,
    serviceProvider: `Oluwarotimi Ogooluwa`,
    jobDescription: `
Be your social media manager and provide shares and signals for your use or ...`,
    address: `24, Nana Avenue, Sangotedo, Lagos`,
    location: `Online`,
    status: `""`,
  })); //build eslint issues

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  const itemsToShow = customerOrders?.slice(startIndex, endIndex);

  const handlePrevPageClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPageClick = () => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return (
    <div className="">
      <section className="mt-2">
        <div className="overflow-x-auto rounded-t-lg">
          <table className="w-full">
            <thead className="bg-[#88087B] text-[#F7F7F7] font-roboto text-sm lg:text-base font-medium text-center whitespace-nowrap">
              <tr>
                <th className="py-6 flex items-center gap-2">
                  Date <MdSort />
                </th>
                <th className="py-3">Amount</th>
                <th className="py-3">Order ID</th>
                <th className="py-3">Service Provider</th>
                <th className="py-3">Job Description</th>
                <th className="py-3">Address</th>
                <th className="py-3">Location</th>
                <th className="py-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item) => (
                <tr
                  onClick={() => {
                    dispatch(addviewOrder(item));
                    navigate("/customers/orderDetails");
                  }}
                  key={item?._id}
                  className="hover:bg-[#87878d] transition duration-300 font-roboto text-xs font-medium leading-normal border border-b-[#525050] text-center"
                >
                  <td className=" py-4">{item?.createdAt}</td>
                  <td className="">{item?.totalPrice}</td>
                  <td className="">{item?._id}</td>
                  <td className="">
                    {item?.serviceProvider?.firstName}{" "}
                    {item?.serviceProvider?.lastName}
                  </td>
                  {/* <td className="">{item?.serviceProvider}</td> */}
                  <td className="px-2">{item?.description}</td>
                  <td className="">{item?.address}</td>
                  <td className="">{item?.location}</td>
                  <td className="">
                    <p className="bg-[#f5d15b] text-[#fff] px-2 rounded-lg">
                      {item?.status}
                    </p>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-end px-4 mt-8 -mb-8">
          <p className="bg-[#88087B] border border-[#88087B] px-2 rounded-md text-[#FFCD1E] text-center text-shadow font-roboto text-base font-medium leading-normal">
            Export
          </p>
        </div>
        <Scrollbar
          currentPage={currentPage}
          totalPages={Math.ceil(totalItems / itemsPerPage)}
          itemsPerPage={itemsPerPage}
          totalItems={totalItems}
          onPrevPageClick={handlePrevPageClick}
          onNextPageClick={handleNextPageClick}
        />
      </section>
    </div>
  );
};

export default Pending;
